<template>
  <div class="home-box">
    <PageTitle title="Edit Tax" class="py-5"></PageTitle>
    <v-row align="center">
      <v-overlay :value="vuexloading" :opacity="1" :color="'#FFFFFF'">
        <v-progress-circular
          color="#FFB300"
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>
      <v-col cols="12" class="home-tabs-body">
        <TaxEditForm />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import TaxEditForm from "@/components/taxes/TaxEditForm.vue";
import PageTitle from "@/components/shared/PageTitle";

export default {
  name: "UpdateTax",
  components: { TaxEditForm, PageTitle },
  computed: {
    vuexloading() {
      return false; // Just for testing, should show the form now
    },
  },
};
</script>
